import React from 'react';

export default class PopupText extends React.Component {
    componentWillMount() {
        this.prepare(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.prepare(nextProps);
    }

    prepare(values) {
        let maxLength = Math.max(...values.data.map(chunk => chunk.toString().replace('.', '').length));
        this.setState({
            data: values.data,
            x: values.x,
            y: values.y,
            width: maxLength * 10 + 10,
        });
    }

    render() {
        return (
            <g>
                <rect x={this.state.x - (this.state.width / 2)}
                      y={this.state.y - 20}
                      height="90"
                      width={this.state.width}
                />
                <text
                    textAnchor="middle"
                    x={this.state.x}
                    y={this.state.y}>
                    <tspan>{this.state.data[3]}</tspan>
                </text>
                <text
                    textAnchor="middle"
                    x={this.state.x}
                    y={this.state.y + 20}>
                    <tspan>{this.state.data[2]}</tspan>
                </text>
                <text
                    textAnchor="middle"
                    x={this.state.x}
                    y={this.state.y + 40}>
                    <tspan>{this.state.data[1]}</tspan>
                </text>
                <text
                    textAnchor="middle"
                    x={this.state.x}
                    y={this.state.y + 60}>
                    <tspan>{this.state.data[0]}</tspan>
                </text>
            </g>
        );
    }
}





// WEBPACK FOOTER //
// ./src/graph-components/popupText.js